import { TableColumn } from "../../types";
import { nameOfKind } from "../../../../services/cpln";
import { OrgIcon } from "../../../../components/Icons/svgComponents/OrgIcon";
import { GvcIcon } from "../../../../components/Icons/svgComponents/GvcIcon";
import { WorkloadIcon } from "../../../../components/Icons/svgComponents/WorkloadIcon";
import { IdentityIcon } from "../../../../components/Icons/svgComponents/IdentityIcon";
import { VolumeSetIcon } from "../../../../components/Icons/svgComponents/VolumeSetIcon";
import { AgentIcon } from "../../../../components/Icons/svgComponents/AgentIcon";
import { AuditContextIcon } from "../../../../components/Icons/svgComponents/AuditContextIcon";
import { CloudAccountIcon } from "../../../../components/Icons/svgComponents/CloudAccountIcon";
import { DomainIcon } from "../../../../components/Icons/svgComponents/DomainIcon";
import { GroupIcon } from "../../../../components/Icons/svgComponents/GroupIcon";
import { ImageIcon } from "../../../../components/Icons/svgComponents/ImageIcon";
import { LocationIcon } from "../../../../components/Icons/svgComponents/LocationIcon";
import { KubernetesIcon } from "../../../../components/Icons/svgComponents/KubernetesIcon";
import { PolicyIcon } from "../../../../components/Icons/svgComponents/PolicyIcon";
import { QuotaIcon } from "../../../../components/Icons/svgComponents/QuotaIcon";
import { SecretIcon } from "../../../../components/Icons/svgComponents/SecretIcon";
import { ServiceAccountIcon } from "../../../../components/Icons/svgComponents/ServiceAccountIcon";
import { UserIcon } from "../../../../components/Icons/svgComponents/UserIcon";

const KindIconMap = {
  org: OrgIcon,
  gvc: GvcIcon,
  workload: WorkloadIcon,
  // "deployment": ,
  identity: IdentityIcon,
  volumeset: VolumeSetIcon,
  //
  // "accessreport": ,
  agent: AgentIcon,
  auditctx: AuditContextIcon,
  cloudaccount: CloudAccountIcon,
  // "command": ,
  // "dbcluster": ,
  domain: DomainIcon,
  // "event": ,
  group: GroupIcon,
  image: ImageIcon,
  imagesummary: ImageIcon,
  location: LocationIcon,
  // "memcachecluster": ,
  mk8s: KubernetesIcon,
  // "permissions": ,
  policy: PolicyIcon,
  // "policymembership": ,
  quota: QuotaIcon,
  // "resource": ,
  // "resourcepolicy": ,
  secret: SecretIcon,
  serviceaccount: ServiceAccountIcon,
  // "spicedbcluster": ,
  // "task": ,
  // "tenant": ,
  user: UserIcon,
};

const kindDefault = { id: "kind", label: "Kind" };
export function KindColumn<TData extends { kind: string }>(column: Partial<TableColumn<TData>> = kindDefault) {
  const preset: TableColumn<TData> = {
    ...kindDefault,
    enableResize: false,
    enableSort: true,
    size: 200,
    cell: (p) => {
      const item = p.row.original;
      if (!item || !item.kind) {
        return <span></span>;
      }
      const KindIcon = KindIconMap[item.kind];
      return (
        <div className="flex items-center">
          <KindIcon style={{ width: 18, height: 18, fill: `var(--color-default)` }} />
          <span className="ml-2 text-sm description">{nameOfKind(item.kind)}</span>
        </div>
      );
    },
  };
  return Object.assign(preset, column);
}
